import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Sellers from "../pages/sellers/page";
import Agents from "../pages/agents/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/sellers",
    element: <Sellers />,
  },
  {
    path: "/agents",
    element: <Agents />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
